import Vue from 'vue';
import { Option } from '@/types/question';
export let shared = {
    suggest_ajaxOptions: {},
    suggest_ajaxPages: {},
};

export function getAllValues (stateId: string, id: string, values?: Option[]) {
    let flattedOptions = values || [];
    Object.keys(shared.suggest_ajaxOptions[id + stateId] || {}).forEach(key => {
        flattedOptions = flattedOptions.concat(shared.suggest_ajaxOptions[id + stateId][key]);
    });
    return flattedOptions.filter(option => option);
}

export function getSharedOptions (ns: string, key: string): Option[] | null {
    if (!shared.suggest_ajaxOptions[ns]) {
        Vue.set(shared.suggest_ajaxOptions, ns, {});
    }

    if (!shared.suggest_ajaxOptions[ns][key]) {
        Vue.set(shared.suggest_ajaxOptions[ns], key, null);
        return shared.suggest_ajaxOptions[ns][key];
    }

    return shared.suggest_ajaxOptions[ns][key];
}

export interface AjaxPageEntity {
    from: number;
    hasMore: boolean;
}

export function getSharedPages (ns: string, search: string): AjaxPageEntity | null {
    if (!shared.suggest_ajaxPages[ns]) {
        Vue.set(shared.suggest_ajaxPages, ns, {});
    }

    if (!shared.suggest_ajaxPages[ns][search]) {
        Vue.set(shared.suggest_ajaxPages[ns], search, null);
        return shared.suggest_ajaxPages[ns][search];
    }

    return shared.suggest_ajaxPages[ns][search];
}
